export default "__VITE_ASSET__CsPS0WnP__"